<template>
  <div id="profile">
    <leavingModal ref="leavingModal"></leavingModal>
    <change-password-modal class="" ref="changePassword"></change-password-modal>
    <change-avatar-modal class="" ref="changeAvatar"></change-avatar-modal>
    <confirm-logout class="" ref="confirmLogout"></confirm-logout>

    <div v-if="!is_transcript" class="left">
      <div>
        <p style="color: #cccccc">User ID</p>
        <div class="user-id">
          <div class="notify-copy">Copied!</div>
          <h4>{{ user_info.student_code }}</h4>
          <img @click="copyText(user_info.student_code)" src="/themes/web/assets/images/icon/icon-copy.svg" alt="" />
        </div>
        <div class="user-reward">
          <img src="/themes/web/assets/images/icon/icon-diamond-tiny.svg" alt="" />
          <p>{{ user_info.reward.diamond | toCommas }}</p>
        </div>
        <div class="user-reward">
          <img src="/themes/web/assets/images/icon/icon-diamond-tiny.svg" alt="" />
          <p>{{ user_info.reward.diamond | toCommas }}</p>
        </div>
        <!-- <div class="user-reward">
                    <img style="position: fixed;" class="crown-tiny" src="/themes/web/assets/images/icon/icon-crown-tiny.svg" alt="">
                    <p style="margin-left: 40px">{{ user_info.reward.crown | toCommas}}</p>
                </div> -->
        <div class="user-avatar">
          <img :src="user_info.avatar_url" alt="" />
        </div>
        <button style="visibility: hidden" class="btn-change-avatar" @click="showChangeAvatarModal()">
          Change Picture
        </button>
      </div>
      <div style="margin: 0">
        <!-- <div class="line"></div> -->
        <!-- <div class="change-password" @click="showChangePasswordModal()">change password</div> -->
        <h4 style="
            color: #ff3d54;
            letter-spacing: 0.02em;
            font-weight: 700;
            font-size: 16px;
            cursor: pointer;
            margin: 0;
            padding-bottom: 32px;
          " @click="onLogout()">
          LOG OUT
        </h4>
      </div>
      <!-- <div class="upgrade">upgrade</div> -->
    </div>
    <div v-if="!is_transcript" class="right">
      <div class="top">
        <!-- <div style="width: 100%; display: flex; justify-content: flex-end;">
                        <button class="btn-save">Save</button>
                    </div> -->
        <div class="form-group" style="position: relative" @mouseover="showTooltip(1)" @mouseleave="hideTooltip(1)">
          <p>Full Name</p>
          <input type="text" disabled :placeholder="user_info.fullname" />
          <div class="tooltip" v-show="isTooltipVisible && user_info.fullname.length >= 49"
            :style="{ top: `80px`, right: `40%` }">
            <div class="tooltip-arrow"></div>
            <span>{{ user_info.fullname }}</span>
          </div>
        </div>
        <div class="form-group">
          <p>Username</p>
          <input type="text" disabled :placeholder="user_info.username" />
        </div>
        <div class="form-group" style="position: relative" @mouseover="showTooltip(2)" @mouseleave="hideTooltip(2)">
          <p>Email</p>
          <input type="text" disabled :placeholder="user_info.email" />
          <div class="tooltip" v-show="isTooltipVisible1 && user_info.email.length >= 49"
            :style="{ top: `80px`, right: `40%` }">
            <div class="tooltip-arrow"></div>
            <span>{{ user_info.email }}</span>
          </div>
        </div>
        <div class="form-group">
          <p>Time zone</p>
          <input type="text" disabled :placeholder="user_info.timezone" />
        </div>
        <div class="list-group">
          <div class="form-group">
            <p>Phone Number</p>
            <input style="width: 220px" type="text" disabled :placeholder="user_info.phone" />
          </div>
          <div class="form-group">
            <p>Grade</p>
            <input type="text" disabled :placeholder="user_info.grade ? `Grade ${user_info.grade}` : ''" />
          </div>
        </div>
        <div class="list-group">
          <div class="form-group">
            <p style="white-space: nowrap">Date of Birth</p>
            <input style="width: 220px" type="text" disabled :placeholder="user_info.birthday | formatDate_1" />
          </div>
          <div class="form-group">
            <p>Gender</p>
            <input type="text" disabled :placeholder="user_info.gender" />
          </div>
        </div>
        <div class="list-group">
          <div class="form-group">
            <p style="white-space: nowrap">Nationality</p>
            <input style="width: 220px" type="text" disabled :placeholder="user_info.nationality" />
          </div>
        </div>
        <!-- <div class="list-group">
                        <div class="form-group">
                            <p>Class</p>
                            <input type="text" disabled placeholder="Class Name">
                        </div>
                        <div class="form-group">
                            <p>Grade</p>
                            <input type="text" disabled :placeholder="'Grade' + profile.grade">
                        </div>
                    </div>
                    <div class="list-group">
                        <div class="form-group">
                            <p>Account Type</p>
                            <input type="text" disabled placeholder="Basic">
                        </div>
                        <div class="form-group">
                            <p>Expiration Date</p>
                            <input type="text" disabled placeholder="31 DEC 2023">
                        </div>
                    </div>
                    <div class="form-group last">
                        <p>Learning since</p>
                        <span>2023-01-01</span>
                    </div> -->
      </div>
      <div class="bottom">
        <!-- <h4 style="color: #FF3D54" @click="onLogout()">LOG OUT</h4> -->
        <!-- <h4>DISABLE MY ACCOUNT</h4>
                    <h4 class="delete">DELETE MY ACCOUNT</h4> -->
        <div class="show-transcript">
          <p>View & download your transcript</p>
          <button @click="showTranscriptModal()" class="btn-show-transcript">
            <img src="/themes/web/assets/images/icon/transcript.svg" alt="" />
            <p>Your Transcript</p>
          </button>
        </div>
      </div>
    </div>
    <div id="transcript" v-if="is_transcript">
      <h3>{{ user_info.fullname }}'s Transcript</h3>
      <div class="group-list">
        <h5>Program</h5>
        <div @click="showListProgram()" class="input-choose">
          <span>{{
            program_name != "" ? program_name : "Select a program"
            }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="10" viewBox="0 0 17 10" fill="none">
            <path d="M1.5 1.5L8.5 8.5L15.5 1.5" stroke="#CFCFCF" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
        <div>
          <p v-if="show_program && filtered_programs.length == 0" class="p-1">
            The student has not been assigned to a program. Please, contact the
            admin team to support.
          </p>
          <p v-if="validate_program" class="p-1">Please, select a program</p>
        </div>
        <div class="list-item" v-if="show_program">
          <div v-for="p in filtered_programs" :key="p.id" @click="getTemplate(p)" class="item">
            {{ p.name }}
          </div>
        </div>
      </div>
      <div class="group-list">
        <h5>Templete</h5>
        <div @click="showListTemplate()" :class="template_name != '' ? 'input-choose' : 'input-choose disabled'
          ">
          <span>{{
            template_name != "" ? template_name : "Select a template"
            }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="10" viewBox="0 0 17 10" fill="none">
            <path d="M1.5 1.5L8.5 8.5L15.5 1.5" stroke="#CFCFCF" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <div>
            <p v-if="
              selected_program != null &&
              selected_program.transcript_template == ''
            " class="p-1">
              The program has no transcript template. Please, contact the admin
              team to support.
            </p>
          </div>
          <!-- <div class="list-item" v-if="template_name">
                        <div class="item">
                            {{ template_name }}
                        </div>
                    </div> -->
        </div>
        <div style="
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
          ">
          <button @click="viewTranscript()" class="btn-show-transcript view">
            <p>View Transcript</p>
          </button>
          <button @click="downloadTranscript()" class="btn-show-transcript download">
            <p>Download Transcript</p>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import changePasswordModal from "../modal/home/changePasswordModal.vue";
import changeAvatarModal from "../modal/home/changeAvatarModal.vue";
import confirmLogout from "../modal/home/confirmLogout.vue";
import leavingModal from "../modal/leavingModal.vue";

import {
  getAvatars,
  getProgramsByUser,
  getAllPrograms,
  viewTranscript,
  deactiveNotiToken,
} from "../../models/profile";
import { isMobileSafari, isMobileDevice } from "@/firebase";

export default {
  name: "Profile",
  title: "Profile",
  components: {
    changePasswordModal,
    changeAvatarModal,
    confirmLogout,
    leavingModal,
  },

  data() {
    return {
      show_program: false,
      is_transcript: false,
      show_template: false,
      program_name: "",
      template_name: "",
      listAvatar: [],
      program_ids: [],
      all_programs: [],
      selected_program: null,
      filtered_programs: [],
      isTooltipVisible: false,
      isTooltipVisible1: false,
      tooltipPosition: {
        top: 0,
        left: 0,
      },
      validate_program: false,
      path: null,
      fromLsp: null,
      previousRoute: null,
    };
  },

  created() {
    this.getAvatars();
  },

  mounted() { },

  beforeDestroy() {
    if (this.fromLsp) {
      if (this.path) {
        this.$router.push({ path: this.path });
      }
    } else {
      if (this.previousRoute && this.previousRoute.path !== this.$route.path) {
        this.$router.push(this.previousRoute.path);
      }
    }
  },

  computed: {
    currentLsp() {
      return this.$store.getters.getCurrentLessonPackage;
    },
    user_info() {
      return this.$store.state.user_info;
    },
  },

  methods: {
    async closeIframe(func) {
      let currentLsp = this.$store.getters.getCurrentLessonPackage;
      const cfm = await this.$refs.leavingModal.show({
        title: "Leaving?",
        message:
          currentLsp?.type == 2
            ? "Please make sure you have saved your work <br>before leaving."
            : "Your answers will not be saved. <br>Are you sure you want to leave?",
        okButton: "Leave now",
        cancelButton: "Cancel",
      });
      if (cfm) {
        this.fromLsp = currentLsp?.from_lsp;
        this.previousRoute = this.$store.state.previousRoute;
        this.path =
          "/lesson-package/" +
          currentLsp?.class_id +
          "/" +
          currentLsp?.course_id +
          "-" +
          currentLsp?.module_id +
          "-" +
          currentLsp?.lesson_id;
        this.$store.commit("setContentChanged", false);
        this.$store.commit("setCurrentLessonPackage", null);
        func();
      } else {
        return false;
      }
    },
    showTooltip(n) {
      // const tooltip = event.currentTarget.querySelector('.tooltip');
      // const rect = event.currentTarget.getBoundingClientRect();
      // const tooltipHeight = tooltip.offsetHeight;
      // const tooltipWidth = tooltip.offsetWidth;

      // this.tooltipPosition.top = rect.top - tooltipHeight - 10;
      // this.tooltipPosition.left = rect.left + rect.width / 2 - tooltipWidth / 2;
      if (n == 1) {
        this.isTooltipVisible = true;
      } else if (n == 2) {
        this.isTooltipVisible1 = true;
      }
    },
    hideTooltip(n) {
      if (n == 1) {
        this.isTooltipVisible = false;
      } else if (n == 2) {
        this.isTooltipVisible1 = false;
      }
    },

    viewTranscript() {
      if (this.selected_program == null) {
        this.validate_program = true;
        return;
      }
      const params = {
        user_id: this.user_info.nosql_id,
        "program_ids[]": this.selected_program.id,
        template: this.selected_program.transcript_template,
        type: "unofficial",
      };
      axios.all([viewTranscript(params)]).then(
        axios.spread((response) => {
          const data = response?.data;
          if (data) {
            const dataUrl = URL.createObjectURL(data);
            if (isMobileDevice(true)) {
              const mimeType = this.getExtensionFromMimeType(data.type);
              this.convertBlobToBase64(data).then((base64) => {
                const message = {
                  type: 'OPEN_FILE',
                  payload: {
                    base64,
                    name: `transcript_data.${mimeType}`,
                  },
                };
                window.FlutterBridge.postMessage(JSON.stringify(message));
              });
            } else {
              window.open(dataUrl, "_blank");
            }
          }
        })
      );
    },
    convertBlobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onloadend = function () {
          const dataUrl = reader.result;
          const base64 = dataUrl.split(',')[1];
          resolve(base64);
        };

        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },
    getExtensionFromMimeType(mimeType) {
      const map = {
        'application/pdf': 'pdf',
        'image/png': 'png',
        'image/jpeg': 'jpg',
        'text/plain': 'txt',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
        'application/msword': 'doc',
        'application/vnd.ms-excel': 'xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
      };
      return map[mimeType] || 'bin';
    },
    downloadTranscript() {
      if (this.selected_program == null) {
        this.validate_program = true;
        return;
      }
      const params = {
        user_id: this.user_info.nosql_id,
        "program_ids[]": this.selected_program.id,
        template: this.selected_program.transcript_template,
        type: "unofficial",
      };
      axios.all([viewTranscript(params)]).then(
        axios.spread(async (response) => {
          const data = response?.data;
          if (data) {
            let dataUrl = URL.createObjectURL(data);
            if (!isMobileDevice(true)) {
              if (isMobileSafari()) {
                const arrayBuffer = await data.arrayBuffer();
                const blob = new Blob([arrayBuffer], { type: 'application/octet-stream' });
                dataUrl = URL.createObjectURL(blob);
              }
              const link = document.createElement("a");
              link.href = dataUrl;
              link.download = "transcript_data.pdf";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } else {
              const mimeType = this.getExtensionFromMimeType(data.type);
              this.convertBlobToBase64(data).then((base64) => {
                const message = {
                  type: 'DOWNLOAD_FILE',
                  payload: {
                    base64: base64,
                    name: `transcript_data.${mimeType}`,
                  },
                };
                window.FlutterBridge.postMessage(JSON.stringify(message));
              });
            }
          }
        })
      );
    },
    getTemplate(program) {
      this.validate_program = false;
      this.selected_program = program;
      this.show_program = false;
      this.program_name = program.name;
      this.template_name = program ? program.transcript_template : "";
    },
    showListProgram() {
      this.show_program = !this.show_program;
    },
    showListTemplate() {
      this.show_template = !this.show_template;
    },
    getAvatars() {
      // axios.all([
      //     getAvatars(),
      // ]).then(axios.spread((response) => {
      //     if (response.data.code != 0) {
      //         return;
      //     }
      //     this.listAvatar = response.data.results.items || [];
      // }));
    },
    async showChangePasswordModal() {
      const cfm = await this.$refs.changePassword.show({
        lang: this.lang,
      });
      if (!cfm) {
        return false;
      }
    },
    async showChangeAvatarModal() {
      const cfm = await this.$refs.changeAvatar.show({
        lang: this.lang,
        listAvatar: this.listAvatar,
      });
      if (!cfm) {
        return false;
      }
    },
    async showTranscriptModal() {

      this.$emit('showTranscript');

      this.is_transcript = true;

      await axios.all([getProgramsByUser(this.user_info.nosql_id)]).then(
        axios.spread((response) => {
          this.program_ids = response.data.program_ids;
        })
      );

      await axios.all([getAllPrograms()]).then(
        axios.spread((response) => {
          this.all_programs = response.data.data;
        })
      );

      this.filtered_programs = this.all_programs.filter((program) => {
        return this.program_ids.includes(program.id);
      });
    },
    copyText(text) {
      navigator.clipboard.writeText(text);

      setTimeout(function () {
        $(".notify-copy").fadeOut();
      }, 1000);

      $(".notify-copy").fadeIn();
    },
    deactiveNotiTokenIpl() {
      let deviceToken = localStorage.getItem("device_token");
      let params = {};
      params.Filter = {
        DeviceToken: deviceToken,
      };

      deactiveNotiToken(params)
        .then((response) => {
          console.log("DeactiveNotiToken Successs");
        })
        .catch((response) => {
          console.log("DeactiveNotiToken failed, please try again later.");
        });
    },
    async onLogout(e) {
      let func = async () => {
        const cfm = await this.$refs.confirmLogout.show({
          lang: this.lang,
        });
        if (cfm) {
          this.deactiveNotiTokenIpl();
          this.$store.dispatch("logout").then(async () => {
            document.cookie =
              "_wid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            document.cookie =
              "_permtoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

            localStorage.removeItem("access_token");
            localStorage.removeItem("device_token");
            localStorage.removeItem(
              `warning_timezone_${this.user_info.username}`
            );
            if (isMobileDevice()) {
              window.FlutterBridge.postMessage("REMOVE_TOKEN");
            }
            this.$router.push({ name: "login" });
          });
        }
      };

      let contentChanged = this.$store.getters.getContentChanged;

      if (this.currentLsp?.type == 1) {
        if (contentChanged) {
          this.closeIframe(func);
        } else {
          func();
        }
      } else {
        if (
          ((this.currentLsp?.status?.toLowerCase() == "todo" ||
            this.currentLsp?.status?.toLowerCase() == "needtoresubmit") &&
            (this.currentLsp?.type == 2 || this.currentLsp?.type == 3)) ||
          (this.currentLsp?.type == 2 &&
            this.currentLsp?.status?.toLowerCase() == "inprogress") ||
          this.currentLsp?.status?.toLowerCase() == "processing"
        ) {
          this.closeIframe(func);
        } else {
          func();
        }
      }
    },
  },
};
</script>

<style scoped>
.tooltip-container {
  /* display: inline-block; */
  position: relative;
}

.tooltip {
  position: absolute;
  color: #000;
  background: #fff;
  padding: 12px 24px;
  border-radius: 12px;
  white-space: nowrap;
  transform: translateY(-10px);
  z-index: 10;
  border: 1px solid #333;
  font-size: 14px;
  font-weight: 500;
  max-width: 320px;
  text-wrap: wrap;
  overflow-wrap: break-word;
}

.tooltip-arrow {
  position: absolute;
  top: -10px;
  left: 45%;
  transform: translateX(100%);
  transform: rotateZ(45deg);
  width: 18px;
  height: 18px;
  background: #fff;
  /* border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-top: 15px solid #fff; */
  border-left: 1px solid #000;
  border-top: 1px solid #000;
}

.tooltip span {
  z-index: 99;
  /* position: absolute;
        z-index: 99; */
}

.p-1 {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.02em;
  text-align: left;
  color: #ff3d54;
  margin-bottom: 10px;
  margin-top: 5px;
}

#transcript .item {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.02em;
  color: #1d1d1f;
  border-bottom: 1px solid #cfcfcf;
  padding: 16px;
  height: 45px;
  background: #fff;
  cursor: pointer;
}

#transcript .item:hover {
  background: #cfcfcf;
}

#transcript .list-item {
  position: absolute;
  width: 100%;
  right: 0;
  left: 0;
  z-index: 2;
  top: 79px;
  border: 1px solid #cfcfcf;
}

#transcript {
  flex: 1;
  padding: 0 50px;
  height: 70vh !important;
}

#transcript .group-list {
  margin-bottom: 10px;
  position: relative;
}

#transcript .input-choose {
  cursor: pointer;
  width: 100%;
  height: 55px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #cfcfcf;
  box-shadow: 2px 2px 0px 0px #cfcfcf;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#transcript .input-choose.disabled {
  background: #dddddd;
}

#transcript h3 {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1d1d1f;
  text-align: center;
  margin-bottom: 30px;
}

#transcript h5 {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1d1d1f;
  margin-bottom: 2px;
}

#transcript span {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.02em;
  color: #777777;
  flex: 1;
}

.show-transcript {
  background: #f8fafc;
  padding: 24px;
  gap: 20px;
  border-radius: 24px;
  display: flex;
  align-items: center;
}

.show-transcript p {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1d1d1f;
}

#profile {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 32px;
}

.left {
  border: 2px solid #dddddd;
  border-radius: 18px;
  width: 400px;
  /* height: 590px; */
}

.user-reward {
  color: #000000;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  margin-bottom: 4px;
}

.user-reward img {
  margin-right: 4px;
}

/* .crown-tiny{
        position: absolute;
        left: 200px;
    } */
.left h4 {
  color: #000000;
  font-weight: 700;
  font-size: 32px;
  margin-right: 16px;
}

.left>p {
  color: #cfcfcf;
  letter-spacing: 0.02em;
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 8px;
}

.left {
  padding: 30px 0;
  padding-bottom: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.user-id {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}

.user-id img {
  cursor: pointer;
}

.user-avatar {
  width: 160px;
  height: 160px;
  overflow: hidden;
  border: 4px solid #5b46b1;
  border-radius: 24px;
  margin: auto;
  margin-bottom: 32px;
  margin-top: 10px;
}

.user-avatar img {
  height: 100%;
  /* height: 160px; */
}

.btn-change-avatar {
  display: none;
  height: 52px;
  width: 179px;
  text-align: center;
  color: #a560eb;
  font-weight: 700;
  font-size: 16px;
  border: 1px solid #cfcfcf;
  box-shadow: 4px 4px 0px #cfcfcf;
  border-radius: 48px;
  cursor: pointer;
  margin-bottom: 32px;
  background: #ffffff;
}

.btn-change-avatar:active {
  position: relative;
  box-shadow: none;
  top: 4px;
  left: 4px;
}

.btn-show-transcript.view {
  margin-top: 30px;
}

.btn-show-transcript.view,
.btn-show-transcript.download {
  width: 381px;
  color: #191715;
}

.btn-show-transcript.download {
  border: 1px solid #e3e87a;
  background: #f8fe5f;
  margin-top: 20px;
  box-shadow: 4px 4px 0px 0px #e3e87a;
}

.btn-show-transcript {
  height: 52px;
  width: 179px;
  text-align: center;
  color: #a560eb;
  font-weight: 700;
  font-size: 16px;
  border: 1px solid #cfcfcf;
  box-shadow: 4px 4px 0px #cfcfcf;
  border-radius: 48px;
  cursor: pointer;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.btn-show-transcript:active {
  position: relative;
  box-shadow: none;
  top: 4px;
  left: 4px;
}

.btn-save {
  height: 52px;
  background: #dddddd;
  border: 1px solid #cfcfcf;
  box-shadow: 4px 4px 0px #cfcfcf;
  border-radius: 48px;
  font-weight: 700;
  font-size: 16px;
  padding: 0 16px;
  cursor: pointer;
  margin-bottom: 20px;
}

.btn-save:active {
  position: relative;
  box-shadow: none;
  top: 4px;
  left: 4px;
}

.line {
  border: 1px solid #cfcfcf;
  width: 100%;
}

.change-password {
  margin-top: 20px;
  margin-bottom: 24px;
  color: #ead4ff;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  cursor: pointer;
}

.upgrade {
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #4c4c4c;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
}

.right {
  width: 100%;
  width: 600px;
}

.right input {
  height: 53px;
  background: #f8fafc;
  border: 1px solid #cfcfcf;
  border-radius: 16px;
  padding: 24px;
  letter-spacing: 0.02em;
  font-size: 16px;
  color: #0d0d0c;
  font-weight: 400;
  width: 484px;
  text-overflow: ellipsis;
  /* width: 464px; */
}

.right .form-group {
  display: flex;
  /* justify-content: space-between; */
  margin-bottom: 8px;
  align-items: center;
  gap: 16px;
}

.list-group {
  display: flex;
  justify-content: space-between;
}

.right .form-group p {
  /* white-space: nowrap; */
  letter-spacing: 0.02em;
  color: #0d0d0c;
  font-weight: 700;
  font-size: 16px;
  width: 100px;
  /* width: 120px; */
  display: flex;
  justify-content: flex-end;
  text-align: end;
}

.form-group.last {
  margin-top: 25px;
}

.form-group.last span {
  letter-spacing: 0.02em;
  color: #afafaf;
  font-weight: 400;
  font-size: 16px;
}

.list-group input {
  width: 148px;
  /* width: 164px; */
}

.bottom {
  /* margin-top: 53px;
        margin-left: calc(120px + 16px); */
}

.bottom>h4 {
  letter-spacing: 0.02em;
  font-weight: 700;
  font-size: 16px;
  color: #afafaf;
  cursor: pointer;
  margin-bottom: 16px;
}

.bottom>h4.delete {
  color: #afafaf;
  color: #ff003d;
}

.notify-copy {
  padding: 8px 16px;
  background-color: rgb(88, 199, 103);
  border-radius: 4px;
  position: absolute;
  right: 40px;
  top: -40px;
  display: none;
}
</style>
